import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { type Tag } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export function getTagsForBrokerageQueryKey () {
  return ['tags']
}

export function useGetTagsForBrokerage () {
  return useQuery<Tag[], GrapeAPIErrorType>({
    queryKey: getTagsForBrokerageQueryKey(),
    queryFn: async () => {
      const response = await fetchWithHeaders(
        '/api/web/brokers/tags'
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    retry: false,
  })
}
